import _ from "lodash";
import React, { useEffect, useMemo, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { FaCircleXmark } from "react-icons/fa6";
import BeatLoader from "react-spinners/BeatLoader";
import {
  useAddBatchMutation,
  useAddTrainingMutation,
  useGetAllCategoryQuery,
  useGetAllTraningsQuery,
  useUpdateBatchMutation,
  useUpdateTrainingMutation,
} from "../../Data/services/trainingApi";
import Toast, { ErrorToast, SuccessToast } from "../../Hooks/useToast";
import { Button, Input, UploadButton } from "../CustomComponents";
import SelectFieldComponent from "../CustomComponents/SelectFieldComponent";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
import { useUploadImageMutation, useUploadImageS3Mutation } from "../../Data/services/profileRequestApi";

const TrainingBatches = ({
  handleUpdateModalClose,
  data,
  handleUpdate,
  refetch,
}) => {
  const { handleSubmit, control, setValue, watch } = useForm({});

  const [updateBatch, { isLoading: addloading }] = useUpdateBatchMutation();
  const [addBatch, { isLoading: editLoading }] = useAddBatchMutation();
  const [UploadImageS3, { isLoading: uploading }] = useUploadImageS3Mutation();
  const [UploadImage, { isLoading: uploadingURL }] = useUploadImageMutation();
  const updateLoading = addloading || editLoading || uploading;
  const { data: training } = useGetAllTraningsQuery({
    search: "",
    limit: 1000,
    page: 1,
  });
  const [userSlug, setUserSlug] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [file, setFile] = useState(null);
  const [imageFiles, setImageFiles] = useState([]);
  const [S3Img, setS3Image] = useState(null)


  const statusList =
    (training?.data &&
      training?.data?.map((x) => {
        return { label: x.name, value: x.id };
      })) ||
    [];

  const [mounted, setMounted] = React.useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (data) {
      console.log(data);
      setUserSlug(data.id);
      setValue("name", data.name);
      setValue("description", data.description);
      setImageFiles([...imageFiles, data.image_url]);
      setValue("training_id", data.training_id);
      setSelectedStatus(data.training_category_id);
      setValue('cover_image_url', data.image_url);
      setValue('image_url', data.image_url)
    }
  }, [data, mounted]);

  const handleStatusChange = (value) => {
    setSelectedStatus(value);
  };

  const isMultileFileUpload = useMemo(() => false, []);
  const fileAcceptParams = useMemo(() => "image/png, image/jpeg", []);
  const cover_image_url = watch("cover_image_url");

  const handleAddfilesAndSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFile(file);
      const doc = URL.createObjectURL(file);
      setImageFiles([...imageFiles, doc]);
    }
  };

  const handleFileChange = async (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
  
    const fileExtension = selectedFile?.name.split(".").pop(); 
    const payload = {
      file_name: `user/${Date.now()}.${fileExtension}`,
      content_type: selectedFile?.type,
    }
  
    try {
      const result = await UploadImageS3({ params: payload }).unwrap();
      setS3Image(result?.data?.presignedUrl); // This is your pre-signed PUT URL
    } catch (e) {
      ErrorToast(e.data?.message || "Upload failed");
    }
  };
  

  const handleImageS3Submit = async () => {
    if (S3Img && file) {
      try {
        const uploadResponse = await fetch(S3Img, {
          method: "PUT",
          headers: {
            "Content-Type": file.type,
          },
          body: file,
        });
        // const result = await UploadImage({ params: S3Img, body: file}).unwrap();
        if (uploadResponse) {
          console.log("Upload successful!");
          return true;
        } else {
          console.error("Upload failed.");
          return false;
        }
      } catch (error) {
        console.error("Upload error:", error);
        return false;
      }
    }
    return false;
  };

  const OnSubmit = async (record) => {
    console.log("called")
    if (!file) {
      delete record["image_url"];
    }

    if (file && S3Img) {
      const uploadSuccess = await handleImageS3Submit();
      if (!uploadSuccess) {
        ErrorToast("Image upload failed");
        return;
      }

      // Extract the final file URL (without query string) to store in DB
      // const uploadedFileUrl = S3Img.split("?")[0];
      // record["image_url"] = uploadedFileUrl || "https://picsum.photos/200/300";
    }

    try {
      const uploadedFileUrl = S3Img ? S3Img.split("?")[0] : data.image_url;
      const payload = {
        slug: userSlug,
        data: { ...record, image_url : uploadedFileUrl},
      };
      let response;
      if (userSlug) {
        response = await updateBatch(payload);
      } else {
        response = await addBatch(payload);
      }

      if (response?.error?.status === 400) {
        console.log(response?.error?.data?.message);
        ErrorToast(response?.error?.data?.message, "error");
      }

      if (response?.error?.status === 500) {
        ErrorToast(response?.error?.data?.message, "error");
      }

      if (response.data) {
        SuccessToast(response?.data?.message);
        handleUpdateModalClose();
        refetch();
      }
    } catch (error) {
      console.log(error)
      if (error?.response && error?.response?.data?.message) {
        Toast(error?.response?.data?.message, "error");
      }
    }
  };

  if (!mounted) {
    return;
  }

  return (
    <div>
      <ModalContainer handleClose={handleUpdateModalClose}>
        <div className={cssStyles.modalContainer}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-semibold m-0 black-text">
              {data ? "Update" : "Add"} Batch
            </p>
            <span className="bg-white bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleUpdateModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
          <div className="w-100">
            <p className="text-body-tertiary">{data?.name}</p>
            <Form onSubmit={handleSubmit(OnSubmit)}>
              <Row>
                <Col sm={12}>
                  <UploadButton
                    label="Upload Cover"
                    classes="mb-2"
                    labelClasses="p-5"
                    isMultileFileUpload={isMultileFileUpload}
                    fileAcceptParams={fileAcceptParams}
                    file={file || cover_image_url}
                    handleFileChange={handleFileChange}
                  />
                </Col>
                <Col md={12}>
                  <p className="m-0 black-text">Batch Name</p>
                  <Controller
                    control={control}
                    name="name"
                    rules={{
                      required: "The Batch Name is required.",
                    }}
                    render={({ field: { onChange, onBlur, value, ref } }) => (
                      <Input
                        type="text"
                        value={value}
                        onChange={onChange}
                        innerRef={ref}
                      />
                    )}
                  />
                </Col>
                <Col md={12}>
                  <p className="m-0 black-text mt-2">Training Name</p>
                  <Controller
                    control={control}
                    name="training_id"
                    rules={{}}
                    defaultValue={selectedStatus}
                    render={({ field: { onChange, onBlur, value, ref } }) => (
                      <SelectFieldComponent
                        firstOption={
                          _.isEmpty(selectedStatus)
                            ? "Select Training"
                            : selectedStatus
                        }
                        optionsList={statusList}
                        onSelectChange={(newValue) => {
                          console.log(newValue);
                          onChange(newValue);
                          setSelectedStatus(newValue);
                        }}
                      />
                    )}
                  />
                </Col>
                <Col md={12}>
                  <p className="m-0 black-text mt-3">Description</p>
                  <Controller
                    control={control}
                    name="description"
                    // defaultValue={subscriptionDescription}
                    render={({ field: { onChange, onBlur, value, ref } }) => (
                      <Input
                        type="text"
                        value={value}
                        onChange={(e) => {
                          onChange(e);
                        }}
                        innerRef={ref}
                        as="textarea"
                        placeholder="Description"
                        rows={4}
                      />
                      //   <Form.Control
                      //     as="textarea"
                      //     rows={3}
                      //     value={value || ""}
                      //     onChange={(e) => {
                      //       onChange(e);
                      //     }}
                      //     placeholder="Description"
                      //   />
                    )}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <Button
                    classes={`${cssStyles.cardBtn} mt-4 ${
                      updateLoading ? "bg-white-subtle" : ""
                    }`}
                    text={
                      updateLoading ? (
                        <BeatLoader size={10} />
                      ) : data ? (
                        "Update"
                      ) : (
                        "Add"
                      )
                    }
                    // onClick={handleSubmit}
                    type="Submit"
                  ></Button>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default TrainingBatches;
